var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "outsety-4" },
    [
      _c(
        "ib-row",
        [
          _c(
            "ib-col",
            { staticClass: "s12 m12 l12 xl6" },
            [
              _c(
                "ib-form",
                [
                  _c("ib-field", {
                    staticClass: "search-field",
                    attrs: {
                      placeholder:
                        this.$t("search_by_company") + "/" + this.$t("ticker"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.checkValidation(_vm.curSearch)
                      },
                    },
                    model: {
                      value: _vm.curSearch,
                      callback: function ($$v) {
                        _vm.curSearch = $$v
                      },
                      expression: "curSearch",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "bg15-inverse cancel",
                      on: {
                        click: function ($event) {
                          return _vm.clearField(true)
                        },
                      },
                    },
                    [
                      _c("svg", { attrs: { viewBox: "0 0 20 20" } }, [
                        _c("path", {
                          attrs: {
                            d: "M10 0a10 10 0 1010 10A10.029 10.029 0 0010 0z",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M14.9 13.5l-1.4 1.4-3.5-3.5-3.5 3.5-1.4-1.4L8.6 10 5.1 6.5l1.4-1.4L10 8.6l3.5-3.5 1.4 1.4-3.5 3.5z",
                            fill: "#fff",
                          },
                        }),
                      ]),
                    ]
                  ),
                  _c(
                    "button",
                    { staticClass: "magnify", on: { click: _vm.submit } },
                    [
                      _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                        _c("path", {
                          attrs: {
                            d: "M21 3C11.6 3 4 10.6 4 20a16.99 16.99 0 0 0 26.1 14.34l12.27 12.28 4.26-4.24-12.13-12.1A16.99 16.99 0 0 0 21 3zm0 4c7.2 0 13 5.8 13 13s-5.8 13-13 13S8 27.2 8 20 13.8 7 21 7z",
                          },
                        }),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }